export default "/images/447c38c84aa14f235f8806ff34cbcdce.avif";